import { Heading } from '@chakra-ui/react';
import CustomTabs from '@Modules/core/components/customTab/CustomTabs';
import FitsFormHandler from '@Modules/terminalManagementSystem/gabManagement/containers/formHandlers/globalSettings/fitsTable/fits/FitsFormHandler';
import FitsNextFormHandler from '@Modules/terminalManagementSystem/gabManagement/containers/formHandlers/globalSettings/fitsTable/fitsNext/FitsNextFormHandler';
import FitsTableFormHandler from '@Modules/terminalManagementSystem/gabManagement/containers/formHandlers/globalSettings/fitsTable/FitsTableFormHandler';
import React from 'react'

const tabHeaders = ['Fits', 'Fits (next)'];

const FitsTablePage = () => {
    const tabContents = React.useMemo(() => [<FitsFormHandler />, <FitsNextFormHandler />], [FitsFormHandler, FitsNextFormHandler])
  return (
    <>
        <Heading size="md">Table Fits</Heading>
        <FitsTableFormHandler />
        <CustomTabs tabHeaders={tabHeaders} tabContents={tabContents} isLazy />
    </>
  )
}

export default FitsTablePage